// Example artist data (replace with real data or props/fetch in future)
import anchorAishwarya from "../assets/images/anchor-aishwarya.png";
import gaurangSahu from "../assets/images/gaurang-sahu.png";
import humraag from "../assets/images/humraag.png";
import rishabhSighBisht from "../assets/images/rishabh-singh-bisht.jpg";
import prateekAggarwal from "../assets/images/prateek-aggarwal.jpg";
import vickyMelophile from "../assets/images/vickyMelophile.jpeg";
import aayan from "../assets/images/aayan.png";

export const ARTISTS: any[] = [
  {
    id: 2,
    name: "Gaurang Sahu",
    slug: "gaurang-sahu",
    image: gaurangSahu,
    artistType: "Instrumentalist",
    tags: ["Flute", "Guitar", "Cajon","+2"],
    score: 92,
  },
  {
    id: 3,
    name: "Humraag",
    slug: "humraag",
    image: humraag,
    artistType: "Band",
    tags: ["Solo", "Duo", "Trio", "Band"],
    score: 88,
  },
  {
    id: 4,
    name: "Rishabh Singh Bisht",
    slug: "rishabh-singh-bisht",
    image: rishabhSighBisht,
    artistType: "Singer",
    tags: ["Bollywood", "Semi-Classical", "Light Music"],
    score: 80,
  },
  {
    id: 5,
    name: "Prateek Aggarwal",
    slug: "prateek-aggarwal",
    image: prateekAggarwal,
    artistType: "Singer",
    tags: [
      "Bollywood Covers",
      "Light Music",
      "Devotional",
      "+4",
    ],
    score: 68,
  },
  {
    id: 1,
    name: "Anchor Aishwarya",
    slug: "anchor-aishwarya",
    image: anchorAishwarya,
    artistType: "Anchor",
    tags: ["Host", "Anchor", "Events"],
    score: 0,
  },
  {
    id: 6,
    name: "Vicky Melophile",
    slug: "vicky-melophile",
    image: vickyMelophile,
    artistType: "Singer",
    tags: ["Bollywood Covers", "Light Music", "Folk","+3"],
    score: 0,
  },
  {
    id: 7,
    name: "Aayan",
    slug: "aayan",
    image: aayan,
    artistType: "Singer",
    tags: ["Bollywood Covers", "Light Music", "Semi-Classical"],
    score: 0,
  }
  // Add more artists as needed
];
